// @ts-nocheck
// TODO 貌似是业务相关
import API from '@/apis/index'
// 记录第一次请求的promise 该promsie保存请求结果
let firstPromsie: any = null

// TODO 考虑服务端
export const isInApp =
  typeof window !== 'undefined' ? /duapp/.test(window.navigator.userAgent) : false

function replaceDomain(newDomain?: string) {
  // eslint-disable-next-line no-restricted-globals
  const href = location.href
  // eslint-disable-next-line no-restricted-globals
  const origin = location.origin
  return newDomain ? href.replace(origin, newDomain) : href
}

/**
 *
 * 获取随机域名  站内才获取 端内逻辑。微信的二次分享不管。
 *
 */
export async function getRandomDomain() {
  if (!firstPromsie) {
    firstPromsie = API.getDomainPool()
      .then(({ status, data }: any) => {
        // 请求成功
        if (status === 200 && data) {
          const RES = {
            domain: data,
            newDomainUrl: replaceDomain(data),
          }
          return RES
        } else {
          const RES = {
            domain: '',
            newDomainUrl: replaceDomain(),
          }
          return RES
        }
      })
      .catch((er: any) => {
        const RES = {
          domain: '',
          newDomainUrl: replaceDomain(),
        }
        return RES
      })
  }
  return firstPromsie
}

/**
 *
 * 域名回溯
 *
 */

// 站外才调用   上报当前域名
export function recallDomain(domain) {
  if (isInApp) return
  // eslint-disable-next-line no-restricted-globals
  const host = location.origin
  // API.recallDomain({ domain: domain ? domain : host })
}
